import { render, staticRenderFns } from "./DetailPageByUINote.vue?vue&type=template&id=5193e109&scoped=true&"
import script from "./DetailPageByUINote.vue?vue&type=script&lang=js&"
export * from "./DetailPageByUINote.vue?vue&type=script&lang=js&"
import style0 from "./DetailPageByUINote.vue?vue&type=style&index=0&id=5193e109&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5193e109",
  null
  
)

export default component.exports